<template>
  <div v-if="isParsedDataEmpty" class="d-flex flex-column gap-3 align-items-center">
    <img :src="require('no_data/reports.svg')" width="255" height="165" alt="no data">
    <span>No data available for this chart.</span>
  </div>
  <div v-else>
    <MainProperties class="m-0" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import MainProperties from 'vue_widgets/reports/show/main_properties'

export default {
  components: {
    MainProperties
  },
  data() {
    return {
      showSettingsPanel: false
    }
  },
  created() {
    this.fetchInsights()
  },
  computed: {
    ...mapState(['isDataLoading', 'gbEnabled', 'parsedData']),
    isParsedDataEmpty() {
      if (!this.parsedData) return true

      return Boolean(Object.keys(this.parsedData).length)
    }
  },
  methods: {
    ...mapActions(['fetchInsights']),
    toggleSettingsPannel() {
      this.showSettingsPanel = !this.showSettingsPanel
    }
  }
}
</script>
